window.CROWN_PRODUCTS = [
  {
    "id": "CG-M01",
    "name": "Polo Performance",
    "category": "Golf",
    "group": "Uomo",
    "audience": "Uomo",
    "price": 165,
    "image": "golf-board-men.webp",
    "crop": [
      0.012322274881516588,
      0.3789403085177733,
      0.26066350710900477,
      0.11468812877263582
    ],
    "sizes": [
      "One Size"
    ],
    "colors": [
      "Nero",
      "Bianco"
    ],
    "description": "Polo Performance — collezione Golf CROWN. Immagine e prezzo ripresi dalla tavola fornita. Taglie, materiali e disponibilità da confermare.",
    "en": "Polo Performance — CROWN Golf collection. Image and price from the supplied collection board. Sizes, materials and availability to be confirmed."
  },
  {
    "id": "CG-M02",
    "name": "Merino Zip Knit",
    "category": "Golf",
    "group": "Uomo",
    "audience": "Uomo",
    "price": 245,
    "image": "golf-board-men.webp",
    "crop": [
      0.2890995260663507,
      0.3796109993293092,
      0.25971563981042656,
      0.11670020120724346
    ],
    "sizes": [
      "One Size"
    ],
    "colors": [
      "Nero",
      "Bianco"
    ],
    "description": "Merino Zip Knit — collezione Golf CROWN. Immagine e prezzo ripresi dalla tavola fornita. Taglie, materiali e disponibilità da confermare.",
    "en": "Merino Zip Knit — CROWN Golf collection. Image and price from the supplied collection board. Sizes, materials and availability to be confirmed."
  },
  {
    "id": "CG-M03",
    "name": "Pantalone Sartoriale Golf",
    "category": "Golf",
    "group": "Uomo",
    "audience": "Uomo",
    "price": 280,
    "image": "golf-board-men.webp",
    "crop": [
      0.566824644549763,
      0.3796109993293092,
      0.22369668246445498,
      0.11670020120724346
    ],
    "sizes": [
      "One Size"
    ],
    "colors": [
      "Nero",
      "Bianco"
    ],
    "description": "Pantalone Sartoriale Golf — collezione Golf CROWN. Immagine e prezzo ripresi dalla tavola fornita. Taglie, materiali e disponibilità da confermare.",
    "en": "Pantalone Sartoriale Golf — CROWN Golf collection. Image and price from the supplied collection board. Sizes, materials and availability to be confirmed."
  },
  {
    "id": "CG-M04",
    "name": "Gilet Tecnico",
    "category": "Golf",
    "group": "Uomo",
    "audience": "Uomo",
    "price": 295,
    "image": "golf-board-men.webp",
    "crop": [
      0.012322274881516588,
      0.5573440643863179,
      0.2559241706161137,
      0.10596914822266935
    ],
    "sizes": [
      "One Size"
    ],
    "colors": [
      "Nero",
      "Bianco"
    ],
    "description": "Gilet Tecnico — collezione Golf CROWN. Immagine e prezzo ripresi dalla tavola fornita. Taglie, materiali e disponibilità da confermare.",
    "en": "Gilet Tecnico — CROWN Golf collection. Image and price from the supplied collection board. Sizes, materials and availability to be confirmed."
  },
  {
    "id": "CG-M05",
    "name": "Blazer Golf",
    "category": "Golf",
    "group": "Uomo",
    "audience": "Uomo",
    "price": 520,
    "image": "golf-board-men.webp",
    "crop": [
      0.2843601895734597,
      0.5573440643863179,
      0.25876777251184835,
      0.10932260228034876
    ],
    "sizes": [
      "One Size"
    ],
    "colors": [
      "Nero",
      "Bianco"
    ],
    "description": "Blazer Golf — collezione Golf CROWN. Immagine e prezzo ripresi dalla tavola fornita. Taglie, materiali e disponibilità da confermare.",
    "en": "Blazer Golf — CROWN Golf collection. Image and price from the supplied collection board. Sizes, materials and availability to be confirmed."
  },
  {
    "id": "CG-M06",
    "name": "Bermuda Golf",
    "category": "Golf",
    "group": "Uomo",
    "audience": "Uomo",
    "price": 210,
    "image": "golf-board-men.webp",
    "crop": [
      0.5649289099526066,
      0.5600268276324615,
      0.22464454976303316,
      0.10529845741113347
    ],
    "sizes": [
      "One Size"
    ],
    "colors": [
      "Nero",
      "Bianco"
    ],
    "description": "Bermuda Golf — collezione Golf CROWN. Immagine e prezzo ripresi dalla tavola fornita. Taglie, materiali e disponibilità da confermare.",
    "en": "Bermuda Golf — CROWN Golf collection. Image and price from the supplied collection board. Sizes, materials and availability to be confirmed."
  },
  {
    "id": "CG-W01",
    "name": "Sculpt Polo",
    "category": "Golf",
    "group": "Donna",
    "audience": "Donna",
    "price": 175,
    "image": "golf-board-women.webp",
    "crop": [
      0.011374407582938388,
      0.37424547283702214,
      0.22938388625592418,
      0.09792085848423876
    ],
    "sizes": [
      "One Size"
    ],
    "colors": [
      "Nero",
      "Bianco"
    ],
    "description": "Sculpt Polo — collezione Golf CROWN. Immagine e prezzo ripresi dalla tavola fornita. Taglie, materiali e disponibilità da confermare.",
    "en": "Sculpt Polo — CROWN Golf collection. Image and price from the supplied collection board. Sizes, materials and availability to be confirmed."
  },
  {
    "id": "CG-W02",
    "name": "Support Top",
    "category": "Golf",
    "group": "Donna",
    "audience": "Donna",
    "price": 185,
    "image": "golf-board-women.webp",
    "crop": [
      0.27582938388625594,
      0.3782696177062374,
      0.20853080568720378,
      0.09389671361502347
    ],
    "sizes": [
      "One Size"
    ],
    "colors": [
      "Nero",
      "Bianco"
    ],
    "description": "Support Top — collezione Golf CROWN. Immagine e prezzo ripresi dalla tavola fornita. Taglie, materiali e disponibilità da confermare.",
    "en": "Support Top — CROWN Golf collection. Image and price from the supplied collection board. Sizes, materials and availability to be confirmed."
  },
  {
    "id": "CG-W03",
    "name": "Tailored Skort",
    "category": "Golf",
    "group": "Donna",
    "audience": "Donna",
    "price": 240,
    "image": "golf-board-women.webp",
    "crop": [
      0.5308056872037915,
      0.38162307176391685,
      0.27014218009478674,
      0.08987256874580818
    ],
    "sizes": [
      "One Size"
    ],
    "colors": [
      "Nero",
      "Bianco"
    ],
    "description": "Tailored Skort — collezione Golf CROWN. Immagine e prezzo ripresi dalla tavola fornita. Taglie, materiali e disponibilità da confermare.",
    "en": "Tailored Skort — CROWN Golf collection. Image and price from the supplied collection board. Sizes, materials and availability to be confirmed."
  },
  {
    "id": "CG-W04",
    "name": "High-Waist Golf Trouser",
    "category": "Golf",
    "group": "Donna",
    "audience": "Donna",
    "price": 295,
    "image": "golf-board-women.webp",
    "crop": [
      0.022748815165876776,
      0.5754527162977867,
      0.16682464454976303,
      0.12340710932260228
    ],
    "sizes": [
      "One Size"
    ],
    "colors": [
      "Nero",
      "Bianco"
    ],
    "description": "High-Waist Golf Trouser — collezione Golf CROWN. Immagine e prezzo ripresi dalla tavola fornita. Taglie, materiali e disponibilità da confermare.",
    "en": "High-Waist Golf Trouser — CROWN Golf collection. Image and price from the supplied collection board. Sizes, materials and availability to be confirmed."
  },
  {
    "id": "CG-W05",
    "name": "Golf Dress",
    "category": "Golf",
    "group": "Donna",
    "audience": "Donna",
    "price": 420,
    "image": "golf-board-women.webp",
    "crop": [
      0.23317535545023696,
      0.5761234071093226,
      0.17440758293838862,
      0.11938296445338699
    ],
    "sizes": [
      "One Size"
    ],
    "colors": [
      "Nero",
      "Bianco"
    ],
    "description": "Golf Dress — collezione Golf CROWN. Immagine e prezzo ripresi dalla tavola fornita. Taglie, materiali e disponibilità da confermare.",
    "en": "Golf Dress — CROWN Golf collection. Image and price from the supplied collection board. Sizes, materials and availability to be confirmed."
  },
  {
    "id": "CG-W06",
    "name": "Light Golf Jacket",
    "category": "Golf",
    "group": "Donna",
    "audience": "Donna",
    "price": 490,
    "image": "golf-board-women.webp",
    "crop": [
      0.43507109004739336,
      0.5767940979208585,
      0.18388625592417063,
      0.12005365526492287
    ],
    "sizes": [
      "One Size"
    ],
    "colors": [
      "Nero",
      "Bianco"
    ],
    "description": "Light Golf Jacket — collezione Golf CROWN. Immagine e prezzo ripresi dalla tavola fornita. Taglie, materiali e disponibilità da confermare.",
    "en": "Light Golf Jacket — CROWN Golf collection. Image and price from the supplied collection board. Sizes, materials and availability to be confirmed."
  },
  {
    "id": "CG-W07",
    "name": "Merino Cardigan",
    "category": "Golf",
    "group": "Donna",
    "audience": "Donna",
    "price": 360,
    "image": "golf-board-women.webp",
    "crop": [
      0.6369668246445498,
      0.5774647887323944,
      0.17725118483412322,
      0.12005365526492287
    ],
    "sizes": [
      "One Size"
    ],
    "colors": [
      "Nero",
      "Bianco"
    ],
    "description": "Merino Cardigan — collezione Golf CROWN. Immagine e prezzo ripresi dalla tavola fornita. Taglie, materiali e disponibilità da confermare.",
    "en": "Merino Cardigan — CROWN Golf collection. Image and price from the supplied collection board. Sizes, materials and availability to be confirmed."
  },
  {
    "id": "CG-A01",
    "name": "Premium Golf Bag",
    "category": "Golf",
    "group": "Accessori",
    "audience": "Accessori",
    "price": 980,
    "image": "golf-board-accessories.webp",
    "crop": [
      0.021800947867298578,
      0.35412474849094566,
      0.11658767772511848,
      0.15358819584171696
    ],
    "sizes": [
      "One Size"
    ],
    "colors": [
      "Nero",
      "Bianco"
    ],
    "description": "Premium Golf Bag — collezione Golf CROWN. Immagine e prezzo ripresi dalla tavola fornita. Taglie, materiali e disponibilità da confermare.",
    "en": "Premium Golf Bag — CROWN Golf collection. Image and price from the supplied collection board. Sizes, materials and availability to be confirmed.",
    "alternateCrop": [
      0.5213270142180095,
      0.3594902749832327,
      0.11943127962085308,
      0.14755197853789404
    ]
  },
  {
    "id": "CG-A02",
    "name": "Weekend Duffel",
    "category": "Golf",
    "group": "Accessori",
    "audience": "Accessori",
    "price": 590,
    "image": "golf-board-accessories.webp",
    "crop": [
      0.14691943127962084,
      0.40778001341381626,
      0.18293838862559242,
      0.10127431254191818
    ],
    "sizes": [
      "One Size"
    ],
    "colors": [
      "Nero",
      "Bianco"
    ],
    "description": "Weekend Duffel — collezione Golf CROWN. Immagine e prezzo ripresi dalla tavola fornita. Taglie, materiali e disponibilità da confermare.",
    "en": "Weekend Duffel — CROWN Golf collection. Image and price from the supplied collection board. Sizes, materials and availability to be confirmed.",
    "alternateCrop": [
      0.6521327014218009,
      0.41582830315224684,
      0.18009478672985782,
      0.09188464118041582
    ]
  },
  {
    "id": "CG-A03",
    "name": "Structured Tote",
    "category": "Golf",
    "group": "Accessori",
    "audience": "Accessori",
    "price": 650,
    "image": "golf-board-accessories.webp",
    "crop": [
      0.33649289099526064,
      0.39101274312541917,
      0.15260663507109004,
      0.11602951039570758
    ],
    "sizes": [
      "One Size"
    ],
    "colors": [
      "Nero",
      "Bianco"
    ],
    "description": "Structured Tote — collezione Golf CROWN. Immagine e prezzo ripresi dalla tavola fornita. Taglie, materiali e disponibilità da confermare.",
    "en": "Structured Tote — CROWN Golf collection. Image and price from the supplied collection board. Sizes, materials and availability to be confirmed.",
    "alternateCrop": [
      0.8417061611374408,
      0.38162307176391685,
      0.13933649289099526,
      0.12608987256874582
    ]
  },
  {
    "id": "CG-A04",
    "name": "Cap",
    "category": "Golf",
    "group": "Accessori",
    "audience": "Accessori",
    "price": 85,
    "image": "golf-board-accessories.webp",
    "crop": [
      0.011374407582938388,
      0.5647216633132126,
      0.11279620853080569,
      0.07511737089201878
    ],
    "sizes": [
      "One Size"
    ],
    "colors": [
      "Nero",
      "Bianco"
    ],
    "description": "Cap — collezione Golf CROWN. Immagine e prezzo ripresi dalla tavola fornita. Taglie, materiali e disponibilità da confermare.",
    "en": "Cap — CROWN Golf collection. Image and price from the supplied collection board. Sizes, materials and availability to be confirmed.",
    "alternateCrop": [
      0.5146919431279621,
      0.5700871898054997,
      0.11753554502369669,
      0.06773977196512408
    ]
  },
  {
    "id": "CG-A05",
    "name": "Visor",
    "category": "Golf",
    "group": "Accessori",
    "audience": "Accessori",
    "price": 90,
    "image": "golf-board-accessories.webp",
    "crop": [
      0.12511848341232226,
      0.574111334674715,
      0.11753554502369669,
      0.06237424547283702
    ],
    "sizes": [
      "One Size"
    ],
    "colors": [
      "Bianco",
      "Nero"
    ],
    "description": "Visor — collezione Golf CROWN. Immagine e prezzo ripresi dalla tavola fornita. Taglie, materiali e disponibilità da confermare.",
    "en": "Visor — CROWN Golf collection. Image and price from the supplied collection board. Sizes, materials and availability to be confirmed.",
    "alternateCrop": [
      0.6350710900473934,
      0.5747820254862508,
      0.1061611374407583,
      0.06170355466130114
    ]
  },
  {
    "id": "CG-A06",
    "name": "Golf Glove",
    "category": "Golf",
    "group": "Accessori",
    "audience": "Accessori",
    "price": 75,
    "image": "golf-board-accessories.webp",
    "crop": [
      0.24928909952606634,
      0.5539906103286385,
      0.07962085308056872,
      0.08584842387659289
    ],
    "sizes": [
      "One Size"
    ],
    "colors": [
      "Bianco"
    ],
    "description": "Golf Glove — collezione Golf CROWN. Immagine e prezzo ripresi dalla tavola fornita. Taglie, materiali e disponibilità da confermare.",
    "en": "Golf Glove — CROWN Golf collection. Image and price from the supplied collection board. Sizes, materials and availability to be confirmed."
  },
  {
    "id": "CG-A07",
    "name": "Luxury Golf Shoes Uomo",
    "category": "Golf",
    "group": "Accessori",
    "audience": "Uomo",
    "price": 320,
    "image": "golf-board-accessories.webp",
    "crop": [
      0.3289099526066351,
      0.5774647887323944,
      0.16303317535545023,
      0.06438631790744467
    ],
    "sizes": [
      "One Size"
    ],
    "colors": [
      "Bianco"
    ],
    "description": "Luxury Golf Shoes Uomo — collezione Golf CROWN. Immagine e prezzo ripresi dalla tavola fornita. Taglie, materiali e disponibilità da confermare.",
    "en": "Luxury Golf Shoes Uomo — CROWN Golf collection. Image and price from the supplied collection board. Sizes, materials and availability to be confirmed."
  },
  {
    "id": "CG-A08",
    "name": "Calze Golf",
    "category": "Golf",
    "group": "Accessori",
    "audience": "Accessori",
    "price": 35,
    "image": "golf-board-accessories.webp",
    "crop": [
      0.011374407582938388,
      0.6901408450704225,
      0.10995260663507109,
      0.10127431254191818
    ],
    "sizes": [
      "One Size"
    ],
    "colors": [
      "Nero",
      "Bianco"
    ],
    "description": "Calze Golf — collezione Golf CROWN. Immagine e prezzo ripresi dalla tavola fornita. Taglie, materiali e disponibilità da confermare.",
    "en": "Calze Golf — CROWN Golf collection. Image and price from the supplied collection board. Sizes, materials and availability to be confirmed."
  },
  {
    "id": "CG-A09",
    "name": "Asciugamano Golf",
    "category": "Golf",
    "group": "Accessori",
    "audience": "Accessori",
    "price": 55,
    "image": "golf-board-accessories.webp",
    "crop": [
      0.12511848341232226,
      0.6881287726358148,
      0.11943127962085308,
      0.0999329309188464
    ],
    "sizes": [
      "One Size"
    ],
    "colors": [
      "Nero"
    ],
    "description": "Asciugamano Golf — collezione Golf CROWN. Immagine e prezzo ripresi dalla tavola fornita. Taglie, materiali e disponibilità da confermare.",
    "en": "Asciugamano Golf — CROWN Golf collection. Image and price from the supplied collection board. Sizes, materials and availability to be confirmed."
  },
  {
    "id": "CG-A10",
    "name": "Ball Pouch",
    "category": "Golf",
    "group": "Accessori",
    "audience": "Accessori",
    "price": 135,
    "image": "golf-board-accessories.webp",
    "crop": [
      0.25118483412322273,
      0.7022132796780685,
      0.11658767772511848,
      0.08786049631120053
    ],
    "sizes": [
      "One Size"
    ],
    "colors": [
      "Nero"
    ],
    "description": "Ball Pouch — collezione Golf CROWN. Immagine e prezzo ripresi dalla tavola fornita. Taglie, materiali e disponibilità da confermare.",
    "en": "Ball Pouch — CROWN Golf collection. Image and price from the supplied collection board. Sizes, materials and availability to be confirmed."
  },
  {
    "id": "CG-A11",
    "name": "Porta Score",
    "category": "Golf",
    "group": "Accessori",
    "audience": "Accessori",
    "price": 120,
    "image": "golf-board-accessories.webp",
    "crop": [
      0.38388625592417064,
      0.6975184439973172,
      0.09573459715639811,
      0.0925553319919517
    ],
    "sizes": [
      "One Size"
    ],
    "colors": [
      "Nero"
    ],
    "description": "Porta Score — collezione Golf CROWN. Immagine e prezzo ripresi dalla tavola fornita. Taglie, materiali e disponibilità da confermare.",
    "en": "Porta Score — CROWN Golf collection. Image and price from the supplied collection board. Sizes, materials and availability to be confirmed."
  },
  {
    "id": "CG-A12",
    "name": "Set Copri Mazze",
    "category": "Golf",
    "group": "Accessori",
    "audience": "Accessori",
    "price": 210,
    "image": "golf-board-accessories.webp",
    "crop": [
      0.5146919431279621,
      0.6941649899396378,
      0.1061611374407583,
      0.096579476861167
    ],
    "sizes": [
      "One Size"
    ],
    "colors": [
      "Nero",
      "Bianco"
    ],
    "description": "Set Copri Mazze — collezione Golf CROWN. Immagine e prezzo ripresi dalla tavola fornita. Taglie, materiali e disponibilità da confermare.",
    "en": "Set Copri Mazze — CROWN Golf collection. Image and price from the supplied collection board. Sizes, materials and availability to be confirmed."
  },
  {
    "id": "CG-A13",
    "name": "Bracciale in Pelle",
    "category": "Golf",
    "group": "Accessori",
    "audience": "Accessori",
    "price": 95,
    "image": "golf-board-accessories.webp",
    "crop": [
      0.6265402843601896,
      0.7196512407780014,
      0.0947867298578199,
      0.056338028169014086
    ],
    "sizes": [
      "One Size"
    ],
    "colors": [
      "Nero",
      "Bianco"
    ],
    "description": "Bracciale in Pelle — collezione Golf CROWN. Immagine e prezzo ripresi dalla tavola fornita. Taglie, materiali e disponibilità da confermare.",
    "en": "Bracciale in Pelle — CROWN Golf collection. Image and price from the supplied collection board. Sizes, materials and availability to be confirmed."
  },
  {
    "id": "CG-A14",
    "name": "Tracolla a Catena",
    "category": "Golf",
    "group": "Accessori",
    "audience": "Accessori",
    "price": 110,
    "image": "golf-board-accessories.webp",
    "crop": [
      0.7251184834123223,
      0.6955063715627096,
      0.06540284360189573,
      0.09456740442655935
    ],
    "sizes": [
      "One Size"
    ],
    "colors": [
      "Oro"
    ],
    "description": "Tracolla a Catena — collezione Golf CROWN. Immagine e prezzo ripresi dalla tavola fornita. Taglie, materiali e disponibilità da confermare.",
    "en": "Tracolla a Catena — CROWN Golf collection. Image and price from the supplied collection board. Sizes, materials and availability to be confirmed."
  },
  {
    "id": "CG-A15",
    "name": "Elastico Capelli",
    "category": "Golf",
    "group": "Accessori",
    "audience": "Accessori",
    "price": 45,
    "image": "golf-board-accessories.webp",
    "crop": [
      0.7933649289099526,
      0.7095908786049631,
      0.09289099526066351,
      0.06841046277665996
    ],
    "sizes": [
      "One Size"
    ],
    "colors": [
      "Nero",
      "Bianco"
    ],
    "description": "Elastico Capelli — collezione Golf CROWN. Immagine e prezzo ripresi dalla tavola fornita. Taglie, materiali e disponibilità da confermare.",
    "en": "Elastico Capelli — CROWN Golf collection. Image and price from the supplied collection board. Sizes, materials and availability to be confirmed."
  },
  {
    "id": "CG-A16",
    "name": "Portachiavi",
    "category": "Golf",
    "group": "Accessori",
    "audience": "Accessori",
    "price": 65,
    "image": "golf-board-accessories.webp",
    "crop": [
      0.8900473933649289,
      0.6981891348088531,
      0.0966824644549763,
      0.08853118712273642
    ],
    "sizes": [
      "One Size"
    ],
    "colors": [
      "Nero",
      "Bianco"
    ],
    "description": "Portachiavi — collezione Golf CROWN. Immagine e prezzo ripresi dalla tavola fornita. Taglie, materiali e disponibilità da confermare.",
    "en": "Portachiavi — CROWN Golf collection. Image and price from the supplied collection board. Sizes, materials and availability to be confirmed."
  },
  {
    "id": "CG-A17",
    "name": "Cintura Uomo",
    "category": "Golf",
    "group": "Accessori",
    "audience": "Uomo",
    "price": 145,
    "image": "golf-board-men.webp",
    "crop": [
      0.012322274881516588,
      0.7565392354124748,
      0.12227488151658768,
      0.05432595573440644
    ],
    "sizes": [
      "One Size"
    ],
    "colors": [
      "Nero"
    ],
    "description": "Cintura Uomo — collezione Golf CROWN. Immagine e prezzo ripresi dalla tavola fornita. Taglie, materiali e disponibilità da confermare.",
    "en": "Cintura Uomo — CROWN Golf collection. Image and price from the supplied collection board. Sizes, materials and availability to be confirmed."
  },
  {
    "id": "CG-A18",
    "name": "Cintura Donna",
    "category": "Golf",
    "group": "Accessori",
    "audience": "Donna",
    "price": 135,
    "image": "golf-board-women.webp",
    "crop": [
      0.25781990521327014,
      0.8128772635814889,
      0.14976303317535544,
      0.05298457411133468
    ],
    "sizes": [
      "One Size"
    ],
    "colors": [
      "Nero"
    ],
    "description": "Cintura Donna — collezione Golf CROWN. Immagine e prezzo ripresi dalla tavola fornita. Taglie, materiali e disponibilità da confermare.",
    "en": "Cintura Donna — CROWN Golf collection. Image and price from the supplied collection board. Sizes, materials and availability to be confirmed."
  },
  {
    "id": "CG-A19",
    "name": "Golf Shoes Donna",
    "category": "Golf",
    "group": "Accessori",
    "audience": "Donna",
    "price": 315,
    "image": "golf-board-women.webp",
    "crop": [
      0.42748815165876775,
      0.8169014084507042,
      0.15545023696682464,
      0.056338028169014086
    ],
    "sizes": [
      "One Size"
    ],
    "colors": [
      "Bianco"
    ],
    "description": "Golf Shoes Donna — collezione Golf CROWN. Immagine e prezzo ripresi dalla tavola fornita. Taglie, materiali e disponibilità da confermare.",
    "en": "Golf Shoes Donna — CROWN Golf collection. Image and price from the supplied collection board. Sizes, materials and availability to be confirmed."
  },
  {
    "id": "CG-A20",
    "name": "Accessory Pouch",
    "category": "Golf",
    "group": "Accessori",
    "audience": "Accessori",
    "price": 140,
    "image": "golf-board-women.webp",
    "crop": [
      0.7440758293838863,
      0.8175720992622401,
      0.12511848341232226,
      0.05097250167672703
    ],
    "sizes": [
      "One Size"
    ],
    "colors": [
      "Nero"
    ],
    "description": "Accessory Pouch — collezione Golf CROWN. Immagine e prezzo ripresi dalla tavola fornita. Taglie, materiali e disponibilità da confermare.",
    "en": "Accessory Pouch — CROWN Golf collection. Image and price from the supplied collection board. Sizes, materials and availability to be confirmed."
  },
  {
    "id": "CRN-W-BLA-001",
    "name": "The Adaptive Blazer",
    "category": "Donna",
    "line": "Travelwear",
    "price": 790,
    "image": "CRN-W-BLA-001.webp",
    "sizes": [
      "XS",
      "S",
      "M",
      "L",
      "XL"
    ],
    "colors": [
      "Nero",
      "Avorio"
    ],
    "description": "Collezione Travelwear CROWN. Immagine di riferimento abbinata al modello nel catalogo fornito. Prezzo e varianti di bozza; composizione, vestibilità e disponibilità da confermare.",
    "en": "CROWN Travelwear collection. Reference image matched to this model in the supplied catalogue. Draft price and variants; composition, fit and availability to be confirmed.",
    "video": "women-blazer.mov",
    "videoPoster": "video-women-blazer.webp"
  },
  {
    "id": "CRN-W-PAN-001",
    "name": "The Travel Pant",
    "category": "Donna",
    "line": "Travelwear",
    "price": 320,
    "image": "women-CRN-W-PAN-001.webp",
    "sizes": [
      "XS",
      "S",
      "M",
      "L",
      "XL"
    ],
    "colors": [
      "Bianco",
      "Nero"
    ],
    "description": "Vita alta. Gamba ampia. Zip oro sulle tasche. Linea lunga. Chiusura laterale.",
    "en": "High waist. Wide leg. Gold pocket zips. Long silhouette. Side fastening.",
    "priceRange": [
      320,
      390
    ],
    "imageAspect": 0.8002853067047075,
    "colorCrops": {
      "Bianco": [
        0.17379679144385027,
        0.2603423680456491,
        0.20499108734402852,
        0.2867332382310984
      ],
      "Nero": [
        0.3627450980392157,
        0.25891583452211125,
        0.24064171122994651,
        0.28815977175463625
      ]
    },
    "lookCrop": [
      0.0142602495543672,
      0.11126961483594865,
      0.6461675579322638,
      0.43651925820256776
    ],
    "details": [
      "Vita alta",
      "Gamba ampia",
      "Zip oro sulle tasche",
      "Linea lunga",
      "Chiusura laterale"
    ],
    "detailsEn": [
      "High waist",
      "Wide leg",
      "Gold pocket zips",
      "Long silhouette",
      "Side fastening"
    ],
    "sourceFile": "171FF911-BF21-448D-B6BC-41B16F15E0DC 2.PNG"
  },
  {
    "id": "CRN-W-JAC-001",
    "name": "The Transit Jacket",
    "category": "Donna",
    "line": "Travelwear",
    "price": 390,
    "image": "women-CRN-W-JAC-001.webp",
    "sizes": [
      "XS",
      "S",
      "M",
      "L",
      "XL"
    ],
    "colors": [
      "Bianco",
      "Nero"
    ],
    "description": "Chiusura full-zip. Collo rialzabile. Tasche con zip oro. Linea sagomata. Zip ai polsini.",
    "en": "Full-zip fastening. Stand-up collar. Gold zipped pockets. Shaped silhouette. Zipped cuffs.",
    "priceRange": [
      390,
      490
    ],
    "imageAspect": 0.8002853067047075,
    "colorCrops": {
      "Bianco": [
        0.0196078431372549,
        0.5713266761768901,
        0.18716577540106952,
        0.15406562054208273
      ],
      "Nero": [
        0.22459893048128343,
        0.5713266761768901,
        0.19340463458110516,
        0.15406562054208273
      ]
    },
    "lookCrop": [
      0.013368983957219251,
      0.12196861626248216,
      0.6470588235294118,
      0.4450784593437946
    ],
    "details": [
      "Chiusura full-zip",
      "Collo rialzabile",
      "Tasche con zip oro",
      "Linea sagomata",
      "Zip ai polsini"
    ],
    "detailsEn": [
      "Full-zip fastening",
      "Stand-up collar",
      "Gold zipped pockets",
      "Shaped silhouette",
      "Zipped cuffs"
    ],
    "sourceFile": "3F46863D-4DA6-4223-B1C6-C6203CA7D939 2.PNG",
    "backCrops": {
      "Bianco": [
        0.42245989304812837,
        0.5713266761768901,
        0.15418894830659535,
        0.15406562054208273
      ],
      "Nero": [
        0.5525846702317291,
        0.5713266761768901,
        0.1265597147950089,
        0.15406562054208273
      ]
    },
    "video": "women-jacket.mov",
    "videoPoster": "video-women-jacket.webp"
  },
  {
    "id": "CRN-W-DRE-001",
    "name": "The Travel Dress",
    "category": "Donna",
    "line": "Travelwear",
    "price": 390,
    "image": "women-CRN-W-DRE-001.webp",
    "sizes": [
      "XS",
      "S",
      "M",
      "L",
      "XL"
    ],
    "colors": [
      "Bianco",
      "Nero"
    ],
    "description": "Spalline larghe. Scollo squadrato. Spacco laterale con zip. Zip sul retro. Logo sul petto.",
    "en": "Wide straps. Square neckline. Zipped side slit. Back zip. Chest logo.",
    "priceRange": [
      390,
      490
    ],
    "imageAspect": 0.8002853067047075,
    "colorCrops": {
      "Bianco": [
        0.0748663101604278,
        0.5542082738944365,
        0.06327985739750445,
        0.13052781740370897
      ],
      "Nero": [
        0.3770053475935829,
        0.5542082738944365,
        0.0677361853832442,
        0.13052781740370897
      ]
    },
    "lookCrop": [
      0.0142602495543672,
      0.11982881597717546,
      0.6461675579322638,
      0.42510699001426533
    ],
    "details": [
      "Spalline larghe",
      "Scollo squadrato",
      "Spacco laterale con zip",
      "Zip sul retro",
      "Logo sul petto"
    ],
    "detailsEn": [
      "Wide straps",
      "Square neckline",
      "Zipped side slit",
      "Back zip",
      "Chest logo"
    ],
    "sourceFile": "B1F5698E-D22C-41D0-9EA3-F9BDA5829D5D 2.PNG",
    "backCrops": {
      "Bianco": [
        0.2192513368983957,
        0.5542082738944365,
        0.059714795008912656,
        0.13052781740370897
      ],
      "Nero": [
        0.5285204991087344,
        0.5542082738944365,
        0.06060606060606061,
        0.13052781740370897
      ]
    },
    "video": "women-dress.mov",
    "videoPoster": "video-women-dress.webp"
  },
  {
    "id": "CRN-M-TRO-001",
    "name": "The Travel Trouser",
    "category": "Uomo",
    "line": "Travelwear",
    "price": 320,
    "priceRange": [
      320,
      390
    ],
    "image": "men-CRN-M-TRO-001.webp",
    "imageAspect": 0.8002853067047075,
    "colorCrops": {
      "Bianco": [
        0.11764705882352941,
        0.49358059914407987,
        0.12745098039215685,
        0.17118402282453637
      ],
      "Nero": [
        0.38324420677361853,
        0.49358059914407987,
        0.1319073083778966,
        0.17118402282453637
      ]
    },
    "lookCrop": [
      0,
      0.1262482168330956,
      0.6283422459893048,
      0.3601997146932953
    ],
    "sizes": [
      "S",
      "M",
      "L",
      "XL",
      "XXL"
    ],
    "colors": [
      "Bianco",
      "Nero"
    ],
    "details": [
      "Linea sartoriale",
      "Vita comfort nascosta",
      "Tasche frontali e posteriori",
      "Fondo pulito",
      "Logo e dettagli oro"
    ],
    "detailsEn": [
      "Tailored silhouette",
      "Concealed comfort waistband",
      "Front and back pockets",
      "Clean hem",
      "Gold logo and details"
    ],
    "description": "Pantalone dalla linea sartoriale, con vita comfort e tasche discrete.",
    "en": "Tailored trousers with a comfort waistband and discreet pockets."
  },
  {
    "id": "CRN-M-JAC-001",
    "name": "The Transit Jacket",
    "category": "Uomo",
    "line": "Travelwear",
    "price": 390,
    "priceRange": [
      390,
      490
    ],
    "image": "men-CRN-M-JAC-001-v2.webp",
    "imageAspect": 0.8002853067047075,
    "colorCrops": {
      "Bianco": [
        0.06684491978609626,
        0.48858773181169757,
        0.22905525846702318,
        0.1768901569186876
      ],
      "Nero": [
        0.3493761140819964,
        0.48858773181169757,
        0.21212121212121213,
        0.1768901569186876
      ]
    },
    "lookCrop": [
      0,
      0.12482168330955777,
      0.6363636363636364,
      0.35805991440798857
    ],
    "sizes": [
      "S",
      "M",
      "L",
      "XL",
      "XXL"
    ],
    "colors": [
      "Bianco",
      "Nero"
    ],
    "details": [
      "Chiusura full-zip",
      "Collo pulito",
      "Tasche discrete",
      "Polsini con zip",
      "Logo e rifiniture oro"
    ],
    "detailsEn": [
      "Full-zip fastening",
      "Clean collar",
      "Discreet pockets",
      "Zipped cuffs",
      "Gold logo and trims"
    ],
    "description": "Giacca full-zip essenziale, con collo pulito e dettagli oro.",
    "en": "An understated full-zip jacket with a clean collar and gold accents.",
    "sourceFile": "03EED58B-6FFD-4D88-B053-5D9A3453C5E5 2.PNG",
    "video": "men-jacket.mov",
    "videoPoster": "video-men-jacket.webp"
  },
  {
    "id": "CRN-M-TEE-001",
    "name": "The Essential Tee",
    "category": "Uomo",
    "line": "Travelwear",
    "price": 140,
    "priceRange": [
      140,
      180
    ],
    "image": "men-CRN-M-TEE-001-v2.webp",
    "imageAspect": 0.8002853067047075,
    "colorCrops": {
      "Bianco": [
        0.04634581105169341,
        0.4921540656205421,
        0.25935828877005346,
        0.1704707560627675
      ],
      "Nero": [
        0.3342245989304813,
        0.4921540656205421,
        0.2531194295900178,
        0.1704707560627675
      ]
    },
    "lookCrop": [
      0,
      0.12482168330955777,
      0.6363636363636364,
      0.35805991440798857
    ],
    "sizes": [
      "S",
      "M",
      "L",
      "XL",
      "XXL"
    ],
    "colors": [
      "Bianco",
      "Nero"
    ],
    "details": [
      "Scollo girocollo",
      "Vestibilità pulita",
      "Logo discreto",
      "Maniche corte",
      "Orlo rifinito"
    ],
    "detailsEn": [
      "Crew neck",
      "Clean fit",
      "Discreet logo",
      "Short sleeves",
      "Finished hem"
    ],
    "description": "T-shirt girocollo dal disegno essenziale. La tavola propone cotone Supima; composizione da confermare.",
    "en": "A clean crew-neck T-shirt. The board proposes Supima cotton; composition to be confirmed.",
    "sourceFile": "27826134-4D1A-4375-8BED-2658C641B605 2.PNG",
    "video": "men-tee.mov",
    "videoPoster": "video-men-tee.webp"
  },
  {
    "id": "CRN-M-OVS-001",
    "name": "The Travel Overshirt",
    "category": "Uomo",
    "line": "Travelwear",
    "price": 390,
    "priceRange": [
      390,
      490
    ],
    "image": "men-CRN-M-OVS-001-v2.webp",
    "imageAspect": 0.8002853067047075,
    "colorCrops": {
      "Bianco": [
        0.06684491978609626,
        0.4864479315263909,
        0.24331550802139038,
        0.16904422253922968
      ],
      "Nero": [
        0.3493761140819964,
        0.4864479315263909,
        0.23529411764705882,
        0.16904422253922968
      ]
    },
    "lookCrop": [
      0,
      0.12482168330955777,
      0.6363636363636364,
      0.35805991440798857
    ],
    "sizes": [
      "S",
      "M",
      "L",
      "XL",
      "XXL"
    ],
    "colors": [
      "Bianco",
      "Nero"
    ],
    "details": [
      "Collo classico",
      "Bottoni oro",
      "Tasche applicate",
      "Polsini con bottone",
      "Logo ricamato"
    ],
    "detailsEn": [
      "Classic collar",
      "Gold buttons",
      "Patch pockets",
      "Button cuffs",
      "Embroidered logo"
    ],
    "description": "Sovracamicia con bottoni e tasche applicate, pensata per abbinamenti da viaggio e città.",
    "en": "An overshirt with buttons and patch pockets, styled for travel and city outfits.",
    "sourceFile": "06B5E428-4AAD-4AF3-8053-973391D79822 2.PNG",
    "video": "men-overshirt.mov",
    "videoPoster": "video-men-overshirt.webp"
  },
  {
    "id": "CRN-M-HOO-001",
    "name": "The Merino Hoodie",
    "category": "Uomo",
    "line": "Travelwear",
    "price": 420,
    "priceRange": [
      420,
      550
    ],
    "image": "men-CRN-M-HOO-001-v2.webp",
    "imageAspect": 0.8002853067047075,
    "colorCrops": {
      "Bianco": [
        0.06862745098039216,
        0.48573466476462196,
        0.22994652406417113,
        0.1718972895863053
      ],
      "Nero": [
        0.35294117647058826,
        0.48573466476462196,
        0.23083778966131907,
        0.1718972895863053
      ]
    },
    "lookCrop": [
      0,
      0.12482168330955777,
      0.6363636363636364,
      0.35805991440798857
    ],
    "sizes": [
      "S",
      "M",
      "L",
      "XL",
      "XXL"
    ],
    "colors": [
      "Bianco",
      "Nero"
    ],
    "details": [
      "Cappuccio essenziale",
      "Cordini con terminali oro",
      "Tasca frontale",
      "Polsini a costina",
      "Logo sul petto"
    ],
    "detailsEn": [
      "Minimal hood",
      "Drawstrings with gold tips",
      "Front pocket",
      "Ribbed cuffs",
      "Chest logo"
    ],
    "description": "Felpa con cappuccio e dettagli oro. La tavola propone merino/cashmere; composizione da confermare.",
    "en": "A hoodie with gold details. The board proposes merino/cashmere; composition to be confirmed.",
    "sourceFile": "743AB215-800C-480F-A7C6-9362C5D9A112 2.PNG"
  },
  {
    "id": "CRN-M-BLA-001",
    "name": "The Adaptive Blazer",
    "category": "Uomo",
    "line": "Travelwear",
    "price": 690,
    "priceRange": [
      690,
      890
    ],
    "image": "men-CRN-M-BLA-001.webp",
    "imageAspect": 0.7075788061703555,
    "colorCrops": {
      "Bianco": [
        0.6701421800947868,
        0.250167672702884,
        0.16966824644549763,
        0.16901408450704225
      ],
      "Nero": [
        0.3791469194312796,
        0.250167672702884,
        0.1734597156398104,
        0.170355466130114
      ]
    },
    "lookCrop": [
      0,
      0.023474178403755867,
      0.376303317535545,
      0.7109322602280349
    ],
    "sizes": [
      "S",
      "M",
      "L",
      "XL",
      "XXL"
    ],
    "colors": [
      "Bianco",
      "Nero"
    ],
    "details": [
      "Rever e collo rialzabile",
      "Chiusura con zip",
      "Tasche multiple",
      "Pannelli posteriori",
      "Logo e dettagli oro"
    ],
    "detailsEn": [
      "Lapels and stand-up collar",
      "Zip fastening",
      "Multiple pockets",
      "Back panels",
      "Gold logo and details"
    ],
    "description": "Blazer dal design versatile, presentato nella tavola in abbinamenti travel, sport e sera.",
    "en": "A versatile blazer shown in travel, sport and evening combinations.",
    "backCrops": {
      "Bianco": [
        0.8360189573459715,
        0.2528504359490275,
        0.14976303317535544,
        0.16633132126089872
      ],
      "Nero": [
        0.5507109004739337,
        0.2515090543259557,
        0.12037914691943127,
        0.1676727028839705
      ]
    },
    "video": "men-blazer.mov",
    "videoPoster": "video-men-blazer.webp"
  },
  {
    "id": "CRN-M-POL-001",
    "name": "The Performance Polo",
    "category": "Uomo",
    "line": "Travelwear",
    "price": 190,
    "priceRange": [
      190,
      240
    ],
    "colors": [
      "Bianco",
      "Nero"
    ],
    "sizes": [
      "S",
      "M",
      "L",
      "XL",
      "XXL"
    ],
    "details": [
      "Collo con profilo oro",
      "Maniche corte con profili oro",
      "Chiusura a bottoni",
      "Logo sul petto",
      "Linea essenziale"
    ],
    "detailsEn": [
      "Gold-trim collar",
      "Gold-trim short sleeves",
      "Button placket",
      "Chest logo",
      "Clean silhouette"
    ],
    "description": "Polo a maniche corte con profili oro e logo sul petto.",
    "en": "A short-sleeve polo with gold trims and a chest logo.",
    "accessory": false,
    "image": "men-CRN-M-POL-001-v2.webp",
    "imageAspect": 0.8002853067047075,
    "colorCrops": {
      "Bianco": [
        0.07754010695187166,
        0.5064194008559201,
        0.24064171122994651,
        0.16690442225392296
      ],
      "Nero": [
        0.3502673796791444,
        0.5064194008559201,
        0.24509803921568626,
        0.16690442225392296
      ]
    },
    "lookCrop": [
      0,
      0.12482168330955777,
      0.6363636363636364,
      0.35805991440798857
    ],
    "sourceFile": "3929FED0-A7A5-4517-A387-F1C0E6F648D2 2.PNG",
    "video": "men-polo.mov",
    "videoPoster": "video-men-polo.webp"
  },
  {
    "id": "CRN-M-BPK-001",
    "name": "The Luxury Backpack",
    "category": "Uomo",
    "line": "Travelwear",
    "price": 290,
    "priceRange": [
      290,
      390
    ],
    "colors": [
      "Bianco",
      "Nero"
    ],
    "sizes": [
      "One Size"
    ],
    "details": [
      "Maniglia superiore",
      "Tasca frontale con zip",
      "Spallacci regolabili",
      "Chiusura con doppia zip",
      "Logo e dettagli oro"
    ],
    "detailsEn": [
      "Top handle",
      "Zipped front pocket",
      "Adjustable shoulder straps",
      "Double-zip fastening",
      "Gold logo and details"
    ],
    "description": "Zaino da viaggio e città con tasca frontale e spallacci regolabili.",
    "en": "A travel and city backpack with a front pocket and adjustable straps.",
    "accessory": true,
    "image": "men-CRN-M-BPK-001-v2.webp",
    "imageAspect": 0.8002853067047075,
    "colorCrops": {
      "Bianco": [
        0.0855614973262032,
        0.4964336661911555,
        0.2014260249554367,
        0.16761768901569188
      ],
      "Nero": [
        0.3484848484848485,
        0.4964336661911555,
        0.20855614973262032,
        0.16761768901569188
      ]
    },
    "lookCrop": [
      0,
      0.12482168330955777,
      0.6363636363636364,
      0.35805991440798857
    ],
    "sourceFile": "F46A3D7E-3C21-4186-8D18-733DD4AB7569 2.PNG",
    "video": "men-backpack.mov",
    "videoPoster": "video-men-backpack.webp"
  },
  {
    "id": "CRN-M-WEK-001",
    "name": "The Weekender",
    "category": "Uomo",
    "line": "Travelwear",
    "price": 390,
    "priceRange": [
      390,
      590
    ],
    "colors": [
      "Bianco",
      "Nero"
    ],
    "sizes": [
      "One Size"
    ],
    "details": [
      "Doppi manici",
      "Tracolla removibile",
      "Chiusura con zip",
      "Tasca interna",
      "Logo e dettagli oro"
    ],
    "detailsEn": [
      "Twin handles",
      "Removable shoulder strap",
      "Zip fastening",
      "Internal pocket",
      "Gold logo and details"
    ],
    "description": "Borsone da viaggio con doppi manici e tracolla removibile.",
    "en": "A travel holdall with twin handles and a removable shoulder strap.",
    "accessory": true,
    "image": "men-CRN-M-WEK-001-v2.webp",
    "imageAspect": 0.8002853067047075,
    "colorCrops": {
      "Bianco": [
        0.0196078431372549,
        0.4864479315263909,
        0.3003565062388592,
        0.16191155492154066
      ],
      "Nero": [
        0.3253119429590018,
        0.4864479315263909,
        0.29322638146167557,
        0.16191155492154066
      ]
    },
    "lookCrop": [
      0,
      0.12482168330955777,
      0.6363636363636364,
      0.35805991440798857
    ],
    "sourceFile": "03D56018-E47D-4EAD-8332-0B066D085A73 2.PNG"
  },
  {
    "id": "CS-M01",
    "name": "Core Support Tee",
    "category": "Sculpt",
    "group": "Uomo",
    "price": 82,
    "currency": "GBP",
    "image": "sculpt-19.webp",
    "imageAspect": 0.8002853067047075,
    "crop": [
      0.0142602495543672,
      0.3559201141226819,
      0.16755793226381463,
      0.14122681883024252
    ],
    "sizes": [
      "One Size"
    ],
    "colors": [
      "Nero",
      "Bianco",
      "Beige",
      "Grigio"
    ],
    "description": "T-shirt aderente a girocollo con logo sul petto. Colori proposti nelle tavole; la foto mostra la variante illustrata. Taglie e caratteristiche tecniche da confermare.",
    "en": "Fitted crew-neck tee with chest logo. Colours proposed in the boards; the photo shows the illustrated variant. Sizes and technical specifications to be confirmed."
  },
  {
    "id": "CS-M02",
    "name": "Travel Sculpt Polo",
    "category": "Sculpt",
    "group": "Uomo",
    "price": 96,
    "currency": "GBP",
    "image": "sculpt-19.webp",
    "imageAspect": 0.8002853067047075,
    "crop": [
      0.18716577540106952,
      0.3537803138373752,
      0.16844919786096257,
      0.14407988587731813
    ],
    "sizes": [
      "One Size"
    ],
    "colors": [
      "Nero",
      "Bianco",
      "Blu navy",
      "Beige"
    ],
    "description": "Polo a maniche corte con chiusura a bottoni. Colori proposti nelle tavole; la foto mostra la variante illustrata. Taglie e caratteristiche tecniche da confermare.",
    "en": "Short-sleeve polo with button placket. Colours proposed in the boards; the photo shows the illustrated variant. Sizes and technical specifications to be confirmed."
  },
  {
    "id": "CS-M03",
    "name": "Second-Skin Base Layer",
    "category": "Sculpt",
    "group": "Uomo",
    "price": 74,
    "currency": "GBP",
    "image": "sculpt-19.webp",
    "imageAspect": 0.8002853067047075,
    "crop": [
      0.3716577540106952,
      0.35805991440798857,
      0.13101604278074866,
      0.14122681883024252
    ],
    "sizes": [
      "One Size"
    ],
    "colors": [
      "Nero",
      "Bianco",
      "Beige"
    ],
    "description": "Canotta da indossare come strato base. Colori proposti nelle tavole; la foto mostra la variante illustrata. Taglie e caratteristiche tecniche da confermare.",
    "en": "Tank top designed as a base layer. Colours proposed in the boards; the photo shows the illustrated variant. Sizes and technical specifications to be confirmed."
  },
  {
    "id": "CS-M04",
    "name": "Sculpt Short",
    "category": "Sculpt",
    "group": "Uomo",
    "price": 54,
    "priceRange": [
      54,
      58
    ],
    "currency": "GBP",
    "image": "sculpt-19.webp",
    "imageAspect": 0.8002853067047075,
    "crop": [
      0.5213903743315508,
      0.3730385164051355,
      0.13458110516934046,
      0.12696148359486448
    ],
    "sizes": [
      "One Size"
    ],
    "colors": [
      "Nero",
      "Bianco",
      "Beige",
      "Grigio"
    ],
    "description": "Boxer con fascia in vita e cuciture sagomate. Colori proposti nelle tavole; la foto mostra la variante illustrata. Taglie e caratteristiche tecniche da confermare.",
    "en": "Boxer shorts with waistband and contoured seams. Colours proposed in the boards; the photo shows the illustrated variant. Sizes and technical specifications to be confirmed."
  },
  {
    "id": "CS-M05",
    "name": "Travel Trouser+",
    "category": "Sculpt",
    "group": "Uomo",
    "price": 128,
    "currency": "GBP",
    "image": "sculpt-19.webp",
    "imageAspect": 0.8002853067047075,
    "crop": [
      0.6916221033868093,
      0.3544935805991441,
      0.10606060606060606,
      0.14407988587731813
    ],
    "sizes": [
      "One Size"
    ],
    "colors": [
      "Nero",
      "Blu navy",
      "Beige"
    ],
    "description": "Pantalone dalla linea sartoriale con fascia interna in vita. Colori proposti nelle tavole; la foto mostra la variante illustrata. Taglie e caratteristiche tecniche da confermare.",
    "en": "Tailored trousers with an internal waistband. Colours proposed in the boards; the photo shows the illustrated variant. Sizes and technical specifications to be confirmed."
  },
  {
    "id": "CS-M06",
    "name": "Motion Sculpt Overshirt",
    "category": "Sculpt",
    "group": "Uomo",
    "price": 148,
    "currency": "GBP",
    "image": "sculpt-19.webp",
    "imageAspect": 0.8002853067047075,
    "crop": [
      0.8279857397504456,
      0.3566333808844508,
      0.16042780748663102,
      0.14265335235378032
    ],
    "sizes": [
      "One Size"
    ],
    "colors": [
      "Nero",
      "Beige",
      "Verde oliva"
    ],
    "description": "Sovracamicia con bottoni e tasche sul petto. Colori proposti nelle tavole; la foto mostra la variante illustrata. Taglie e caratteristiche tecniche da confermare.",
    "en": "Buttoned overshirt with chest pockets. Colours proposed in the boards; the photo shows the illustrated variant. Sizes and technical specifications to be confirmed."
  },
  {
    "id": "CS-W01",
    "name": "Sculpt Support Bra",
    "category": "Sculpt",
    "group": "Donna",
    "price": 68,
    "currency": "GBP",
    "image": "sculpt-18.webp",
    "imageAspect": 0.8002853067047075,
    "crop": [
      0.016042780748663103,
      0.3680456490727532,
      0.15775401069518716,
      0.12268188302425106
    ],
    "sizes": [
      "One Size"
    ],
    "colors": [
      "Nero",
      "Avorio",
      "Beige"
    ],
    "description": "Reggiseno con spalline e coppe sagomate. Colori proposti nelle tavole; la foto mostra la variante illustrata. Taglie e caratteristiche tecniche da confermare.",
    "en": "Bra with shoulder straps and shaped cups. Colours proposed in the boards; the photo shows the illustrated variant. Sizes and technical specifications to be confirmed."
  },
  {
    "id": "CS-W02",
    "name": "2-in-1 Sculpt Tee",
    "category": "Sculpt",
    "group": "Donna",
    "price": 78,
    "priceRange": [
      78,
      82
    ],
    "currency": "GBP",
    "image": "sculpt-18.webp",
    "imageAspect": 0.8002853067047075,
    "crop": [
      0.18805704099821746,
      0.362339514978602,
      0.15775401069518716,
      0.137660485021398
    ],
    "sizes": [
      "One Size"
    ],
    "colors": [
      "Nero",
      "Avorio",
      "Beige"
    ],
    "description": "T-shirt aderente con struttura interna integrata. Colori proposti nelle tavole; la foto mostra la variante illustrata. Taglie e caratteristiche tecniche da confermare.",
    "en": "Fitted tee with an integrated inner structure. Colours proposed in the boards; the photo shows the illustrated variant. Sizes and technical specifications to be confirmed."
  },
  {
    "id": "CS-W03",
    "name": "Travel Sculpt Dress",
    "category": "Sculpt",
    "group": "Donna",
    "price": 128,
    "currency": "GBP",
    "image": "sculpt-dress-board.webp",
    "imageAspect": 0.8002853067047075,
    "crop": [
      0.3609625668449198,
      0.3601997146932953,
      0.15240641711229946,
      0.15263908701854492
    ],
    "sizes": [
      "One Size"
    ],
    "colors": [
      "Bianco",
      "Beige",
      "Nero"
    ],
    "description": "Abito Sculpt con spalline larghe, scollo squadrato e drappeggio laterale. Varianti: bianco, beige e nero. La foto del capo mostra il nero; foto singole delle varianti bianco e beige da aggiungere. Taglie, composizione e struttura interna da confermare.",
    "en": "Sculpt dress with wide straps, a square neckline and side draping. Variants: white, beige and black. The product photo shows black; individual white and beige photos are to be added. Sizes, composition and internal construction to be confirmed."
  },
  {
    "id": "CS-W04",
    "name": "Sculpt Pant",
    "category": "Sculpt",
    "group": "Donna",
    "price": 72,
    "priceRange": [
      72,
      78
    ],
    "currency": "GBP",
    "image": "sculpt-18.webp",
    "imageAspect": 0.8002853067047075,
    "crop": [
      0.5267379679144385,
      0.362339514978602,
      0.13903743315508021,
      0.15049928673323823
    ],
    "sizes": [
      "One Size"
    ],
    "colors": [
      "Nero",
      "Avorio",
      "Beige",
      "Grigio"
    ],
    "description": "Pantalone aderente a vita alta con cuciture sagomate. Colori proposti nelle tavole; la foto mostra la variante illustrata. Taglie e caratteristiche tecniche da confermare.",
    "en": "High-waisted fitted pants with contoured seams. Colours proposed in the boards; the photo shows the illustrated variant. Sizes and technical specifications to be confirmed."
  },
  {
    "id": "CS-W05",
    "name": "Second-Skin Shaping Short",
    "category": "Sculpt",
    "group": "Donna",
    "price": 48,
    "priceRange": [
      48,
      54
    ],
    "currency": "GBP",
    "image": "sculpt-18.webp",
    "imageAspect": 0.8002853067047075,
    "crop": [
      0.6818181818181818,
      0.37089871611982883,
      0.1497326203208556,
      0.1340941512125535
    ],
    "sizes": [
      "One Size"
    ],
    "colors": [
      "Nero",
      "Beige",
      "Avorio"
    ],
    "description": "Short sottoveste a vita alta. Colori proposti nelle tavole; la foto mostra la variante illustrata. Taglie e caratteristiche tecniche da confermare.",
    "en": "High-waisted underlayer shorts. Colours proposed in the boards; the photo shows the illustrated variant. Sizes and technical specifications to be confirmed."
  },
  {
    "id": "CS-W06",
    "name": "Sculpt Skirt",
    "category": "Sculpt",
    "group": "Donna",
    "price": 96,
    "currency": "GBP",
    "image": "sculpt-18.webp",
    "imageAspect": 0.8002853067047075,
    "crop": [
      0.8422459893048129,
      0.36590584878744653,
      0.14527629233511585,
      0.14550641940085593
    ],
    "sizes": [
      "One Size"
    ],
    "colors": [
      "Nero",
      "Avorio"
    ],
    "description": "Gonna con drappeggio e short interno. Colori proposti nelle tavole; la foto mostra la variante illustrata. Taglie e caratteristiche tecniche da confermare.",
    "en": "Draped skirt with inner shorts. Colours proposed in the boards; the photo shows the illustrated variant. Sizes and technical specifications to be confirmed."
  },
  {
    "id": "CRN-W-KNI-001",
    "name": "The Soft Knit",
    "category": "Donna",
    "line": "Travelwear",
    "price": 350,
    "priceRange": [
      350,
      450
    ],
    "image": "women-CRN-W-KNI-001.webp",
    "imageAspect": 0.8002853067047075,
    "colorCrops": {
      "Bianco": [
        0.06060606060606061,
        0.5827389443651926,
        0.23172905525846701,
        0.12838801711840228
      ],
      "Nero": [
        0.3680926916221034,
        0.5827389443651926,
        0.23083778966131907,
        0.12838801711840228
      ]
    },
    "lookCrop": [
      0.012477718360071301,
      0.12410841654778887,
      0.6470588235294118,
      0.4529243937232525
    ],
    "sizes": [
      "XS",
      "S",
      "M",
      "L",
      "XL"
    ],
    "colors": [
      "Bianco",
      "Nero"
    ],
    "details": [
      "Girocollo a costina",
      "Zip oro sulla spalla",
      "Zip ai polsini",
      "Bordo a costina",
      "Logo sul petto"
    ],
    "detailsEn": [
      "Ribbed crew neck",
      "Gold shoulder zip",
      "Zipped cuffs",
      "Ribbed hem",
      "Chest logo"
    ],
    "description": "Girocollo a costina. Zip oro sulla spalla. Zip ai polsini. Bordo a costina. Logo sul petto.",
    "en": "Ribbed crew neck. Gold shoulder zip. Zipped cuffs. Ribbed hem. Chest logo.",
    "sourceFile": "1F05D58C-3516-4CD0-94D9-F50CBC1BE213 2.PNG",
    "video": "women-knit.mov",
    "videoPoster": "video-women-knit.webp"
  },
  {
    "id": "CRN-W-TEE-001",
    "name": "The Essential Tee",
    "category": "Donna",
    "line": "Travelwear",
    "price": 140,
    "priceRange": [
      140,
      180
    ],
    "image": "women-CRN-W-TEE-001.webp",
    "imageAspect": 0.8002853067047075,
    "colorCrops": {
      "Bianco": [
        0.05080213903743316,
        0.5748930099857347,
        0.18449197860962566,
        0.12054208273894436
      ],
      "Nero": [
        0.2638146167557932,
        0.5748930099857347,
        0.17379679144385027,
        0.12054208273894436
      ]
    },
    "lookCrop": [
      0.012477718360071301,
      0.11483594864479316,
      0.6417112299465241,
      0.4543509272467903
    ],
    "sizes": [
      "XS",
      "S",
      "M",
      "L",
      "XL"
    ],
    "colors": [
      "Bianco",
      "Nero"
    ],
    "details": [
      "Girocollo",
      "Maniche corte",
      "Zip laterali",
      "Zip posteriore",
      "Logo sul petto"
    ],
    "detailsEn": [
      "Crew neck",
      "Short sleeves",
      "Side zips",
      "Back zip",
      "Chest logo"
    ],
    "description": "Girocollo. Maniche corte. Zip laterali. Zip posteriore. Logo sul petto.",
    "en": "Crew neck. Short sleeves. Side zips. Back zip. Chest logo.",
    "sourceFile": "C3C7EA4C-C3BD-4AE8-B462-BAC0E2A67940 2.PNG",
    "video": "women-tee.mov",
    "videoPoster": "video-women-tee.webp"
  }
];
// Additional model photography, linked only when the file is validated.
const CROWN_WORN_IDS=new Set(["CG-M01", "CG-M02", "CG-M03", "CG-M04", "CG-M05", "CG-M06", "CG-W01", "CG-W02", "CG-W03", "CG-W04", "CG-W05", "CG-W06", "CG-W07", "CG-A01", "CG-A02", "CG-A03", "CG-A04", "CG-A05", "CG-A06", "CG-A07", "CG-A08", "CG-A09", "CG-A10", "CG-A11", "CG-A12", "CG-A13", "CG-A14", "CG-A15", "CG-A16", "CG-A17", "CG-A18", "CG-A19", "CG-A20", "CRN-W-BLA-001", "CRN-W-PAN-001", "CRN-W-JAC-001", "CRN-W-DRE-001", "CRN-M-TRO-001", "CRN-M-JAC-001", "CRN-M-TEE-001", "CRN-M-OVS-001", "CRN-M-HOO-001", "CRN-M-BLA-001", "CRN-M-POL-001", "CRN-M-BPK-001", "CRN-M-WEK-001", "CS-M01", "CS-M02", "CS-M03", "CS-M04", "CS-M05", "CS-M06", "CS-W02", "CS-W03", "CS-W04", "CS-W05", "CS-W06", "CRN-W-KNI-001", "CRN-W-TEE-001"]);
window.CROWN_PRODUCTS.forEach(p=>{if(CROWN_WORN_IDS.has(p.id)){p.wornImage="worn-"+p.id+".webp";p.wornColor=({"CS-M05":"Beige","CS-W03":"Nero","CS-W05":"Beige"})[p.id]||p.colors[0];}});

// Full demo apparel size range, ordered from smallest to largest.
window.CROWN_PRODUCTS.forEach(p=>{
 if(['CRN-M-BPK-001','CRN-M-WEK-001'].includes(p.id)||p.id.startsWith('CG-A'))return;
 const gender=['Uomo','Donna'].includes(p.group)?p.group:p.category;
 if(gender==='Uomo'){p.sizes=['S','M','L','XL','XXL'];p.sizeGuide='men';}
 if(gender==='Donna'){p.sizes=['XS','S','M','L','XL'];p.sizeGuide='women';}
});

// Product-only views: never use an entire editorial board as a product photo.
window.CROWN_PRODUCTS.forEach(p=>{
 if(p.id==='CRN-W-BLA-001'){
  p.imageAspect=683/555;p.flatCrops={Nero:[398/683,174/555,162/683,244/555]};
  p.description='Blazer donna dalla linea sagomata, con collo alto, chiusura zip e dettagli oro. Taschino sul petto e tasche con pattina.';
  p.en='A shaped women’s blazer with a stand collar, zip fastening and gold accents. Chest pocket and flap pockets.';
  p.details=['Linea sagomata','Collo alto','Chiusura con zip','Tasche con pattina','Dettagli oro'];
  p.detailsEn=['Shaped silhouette','Stand collar','Zip fastening','Flap pockets','Gold accents'];
 }else if(p.colorCrops)p.flatCrops=p.colorCrops;
 else if(p.id.startsWith('CG-M')||p.id.startsWith('CG-W')){
  const [x,y,w,h]=p.crop;p.flatCrops={Nero:[x,y,w/2,h],Bianco:[x+w/2,y,w/2,h]};
 }else if(p.crop){
  const illustrated=({'CS-M03':'Bianco','CS-M05':'Beige','CS-W03':'Nero','CS-W05':'Beige'})[p.id]||p.colors[0];
  p.flatCrops={[illustrated]:p.crop};if(p.alternateCrop)p.flatCrops[p.colors[1]]=p.alternateCrop;
 }
});





window.CROWN_PRODUCTS.find(p=>p.id==='CRN-W-DRE-001').wornImage='discreet/dress-white-worn.webp';
window.CROWN_PRODUCTS.find(p=>p.id==='CRN-M-POL-001').wornImage='discreet/polo-white-worn.webp';

window.CROWN_PRODUCTS.find(p=>p.id==='CRN-M-TEE-001').wornImage='discreet/tee-white-worn.webp';

// BEGIN DISCREET ALL
[["CG-A01","discreet/CG-A01.webp"],["CG-A02","discreet/CG-A02.webp"],["CG-A03","discreet/CG-A03.webp"],["CG-A04","discreet/CG-A04.webp"],["CG-A05","discreet/CG-A05.webp"],["CG-A06","discreet/CG-A06.webp"],["CG-A07","discreet/CG-A07.webp"],["CG-A08","discreet/CG-A08.webp"],["CG-A09","discreet/CG-A09.webp"],["CG-A10","discreet/CG-A10.webp"],["CG-A11","discreet/CG-A11.webp"],["CG-A12","discreet/CG-A12.webp"],["CG-A13","discreet/CG-A13.webp"],["CG-A14","discreet/CG-A14.webp"],["CG-A15","discreet/CG-A15.webp"],["CG-A16","discreet/CG-A16.webp"],["CG-A17","discreet/CG-A17.webp"],["CG-A18","discreet/CG-A18.webp"],["CG-A19","discreet/CG-A19.webp"],["CG-A20","discreet/CG-A20.webp"],["CG-M01","discreet/CG-M01.webp"],["CG-M02","discreet/CG-M02.webp"],["CG-M03","discreet/CG-M03.webp"],["CG-M04","discreet/CG-M04.webp"],["CG-M05","discreet/CG-M05.webp"],["CG-M06","discreet/CG-M06.webp"],["CG-W01","discreet/CG-W01.webp"],["CG-W02","discreet/CG-W02.webp"],["CG-W03","discreet/CG-W03.webp"],["CG-W04","discreet/CG-W04.webp"],["CG-W05","discreet/CG-W05.webp"],["CG-W06","discreet/CG-W06.webp"],["CG-W07","discreet/CG-W07.webp"],["CRN-M-BLA-001","discreet/CRN-M-BLA-001.webp"],["CRN-M-BPK-001","discreet/CRN-M-BPK-001.webp"],["CRN-M-HOO-001","discreet/CRN-M-HOO-001.webp"],["CRN-M-JAC-001","discreet/CRN-M-JAC-001.webp"],["CRN-M-OVS-001","discreet/CRN-M-OVS-001.webp"],["CRN-M-TRO-001","discreet/CRN-M-TRO-001.webp"],["CRN-M-WEK-001","discreet/CRN-M-WEK-001.webp"],["CRN-W-BLA-001","discreet/CRN-W-BLA-001.webp"],["CRN-W-JAC-001","discreet/CRN-W-JAC-001.webp"],["CRN-W-KNI-001","discreet/CRN-W-KNI-001.webp"],["CRN-W-PAN-001","discreet/CRN-W-PAN-001.webp"],["CRN-W-TEE-001","discreet/CRN-W-TEE-001.webp"],["CS-M01","discreet/CS-M01.webp"],["CS-M02","discreet/CS-M02.webp"],["CS-M03","discreet/CS-M03.webp"],["CS-M04","discreet/CS-M04.webp"],["CS-M05","discreet/CS-M05.webp"],["CS-M06","discreet/CS-M06.webp"],["CS-W02","discreet/CS-W02.webp"],["CS-W03","discreet/CS-W03.webp"],["CS-W04","discreet/CS-W04.webp"],["CS-W05","discreet/CS-W05.webp"],["CS-W06","discreet/CS-W06.webp"]].forEach(([id,image])=>{const p=window.CROWN_PRODUCTS.find(p=>p.id===id);if(p)p.wornImage=image;});
window.CROWN_PRODUCTS.forEach(p=>{if(p.wornImage?.startsWith("discreet/")){p.wornSmall=p.wornImage.replace(".webp","-512.webp");if(p.video)p.videoPoster=p.wornSmall;}});
// END DISCREET ALL

// Sculpt Éclat Midi — concept supplied 21 October 2026
window.CROWN_PRODUCTS.push({"id": "CS-W-ECL-001", "name": "Sculpt Éclat Midi", "category": "Sculpt", "group": "Donna", "audience": "Donna", "line": "Sculpt", "price": 429, "currency": "EUR", "colors": ["Bianco", "Nero"], "sizes": ["XS","S","M","L","XL"], "sizeGuide": "women", "image": "eclat/originale.png", "wornImage": "eclat/look-nero.webp", "wornColor": "Nero", "description": "Abito midi con scollo a cuore e sistema body Sculpt integrato. Linea aderente, spalline sottili e dettagli metallici gold tone.", "en": "Sweetheart midi dress with an integrated Sculpt bodysuit, slim straps and gold-tone details.", "video": "eclat-Reel_9s.mp4", "videoPoster": "eclat/look-nero.webp", "details": ["Sostegno seno integrato", "Pannello addominale modellante", "Body interno con apertura al cavallo", "Tessuto traspirante ad alta elasticità", "Effetto silhouette levigata", "Dettagli metallici gold tone"]});

// Commercial update requested on 22 October 2026.
// Existing numeric prices are the new EUR list prices, not exchange-rate conversions.
window.CROWN_PRODUCTS.forEach(p=>{p.currency='EUR';delete p.priceRange;});
const CROWN_CONFIRMED_SIZES={
 'CG-A07':['39','40','41','42','43','44','45','46'],
 'CG-A19':['36','37','38','39','40','41'],
 'CG-A06':['S','M','L','XL'],
 'CG-A17':['S','M','L'],
 'CG-A18':['S','M','L']
};
window.CROWN_PRODUCTS.forEach(p=>{if(CROWN_CONFIRMED_SIZES[p.id])p.sizes=CROWN_CONFIRMED_SIZES[p.id];});

// Product copy reviewed 31 October 2026. No unverified fabric or performance claims.
const CROWN_PRODUCT_COPY_20261031={"CG-M01":{"it":"Polo uomo a maniche corte, con colletto, abbottonatura e logo CROWN sul petto. Un capo da abbinare ai pantaloni della collezione Golf.","en":"A men’s short-sleeve polo with a collar, button placket and CROWN chest logo. Pair it with trousers from the Golf collection.","nameEn":"Polo Performance"},"CG-M02":{"it":"Maglia uomo con chiusura zip della collezione Golf CROWN. Da abbinare a polo e pantaloni Golf.","en":"A men’s zip-neck knit from the CROWN Golf collection. Style it with a polo and Golf trousers.","nameEn":"Merino Zip Knit"},"CG-M03":{"it":"Pantalone uomo dalla linea sartoriale, parte della collezione Golf CROWN. Completa il look con una polo e gli accessori coordinati.","en":"Men’s tailored-style trousers from the CROWN Golf collection. Complete the look with a polo and matching accessories.","nameEn":"Tailored Golf Trousers"},"CG-M04":{"it":"Gilet uomo della collezione Golf CROWN, da indossare sopra una polo per un look a strati.","en":"A men’s vest from the CROWN Golf collection, styled over a polo for a layered look.","nameEn":"Golf Vest"},"CG-M05":{"it":"Blazer uomo della collezione Golf CROWN. Una proposta per completare il guardaroba dal campo al club.","en":"A men’s blazer from the CROWN Golf collection. A finishing layer for a wardrobe that moves from the course to the clubhouse.","nameEn":"Golf Blazer"},"CG-M06":{"it":"Bermuda uomo della collezione Golf CROWN, da abbinare a polo, cintura e calzature della collezione.","en":"Men’s shorts from the CROWN Golf collection. Pair with a polo, belt and Golf shoes.","nameEn":"Golf Shorts"},"CG-W01":{"it":"Polo donna della collezione Golf CROWN. Abbinala a Tailored Skort o ai pantaloni Golf per un look coordinato.","en":"A women’s polo from the CROWN Golf collection. Pair with the Tailored Skort or Golf trousers for a coordinated look.","nameEn":"Sculpt Polo"},"CG-W02":{"it":"Top donna della collezione Golf CROWN, da abbinare alla selezione di gonne pantalone e pantaloni.","en":"A women’s top from the CROWN Golf collection, styled with the collection’s skorts and trousers.","nameEn":"Support Top"},"CG-W03":{"it":"Gonna pantalone della collezione Golf CROWN. Una proposta da completare con polo e accessori coordinati.","en":"A skort from the CROWN Golf collection. Complete the outfit with a polo and matching accessories.","nameEn":"Tailored Skort"},"CG-W04":{"it":"Pantalone donna a vita alta della collezione Golf CROWN. Da abbinare a polo, top o cardigan.","en":"High-waisted women’s trousers from the CROWN Golf collection. Style with a polo, top or cardigan.","nameEn":"High-Waist Golf Trouser"},"CG-W05":{"it":"Abito Golf donna senza maniche, con colletto, apertura con zip e logo CROWN. La linea a contrasto riprende i colori della collezione.","en":"A sleeveless women’s Golf dress with a collar, zip neckline and CROWN logo. Contrasting panels echo the collection’s colour palette.","nameEn":"Golf Dress"},"CG-W06":{"it":"Giacca donna della collezione Golf CROWN, da abbinare ai capi e agli accessori della stessa linea.","en":"A women’s jacket from the CROWN Golf collection, styled with the line’s clothing and accessories.","nameEn":"Light Golf Jacket"},"CG-W07":{"it":"Cardigan donna della collezione Golf CROWN. Da indossare sopra il top o la polo della collezione.","en":"A women’s cardigan from the CROWN Golf collection. Layer over a top or polo from the collection.","nameEn":"Merino Cardigan"},"CG-A01":{"it":"Sacca da golf CROWN con tasche esterne e dettagli a contrasto. Per la dotazione inclusa e le dimensioni specifiche, contatta l’assistenza prima dell’ordine.","en":"A CROWN golf bag with exterior pockets and contrasting details. Contact customer care before ordering for the included items and exact dimensions.","nameEn":"Premium Golf Bag"},"CG-A02":{"it":"Borsone della collezione Golf CROWN, con doppi manici e chiusura zip. Per completare il look da viaggio e da club.","en":"A Golf collection duffel bag with twin handles and zip fastening. A finishing piece for travel and clubhouse outfits.","nameEn":"Weekend Duffel"},"CG-A03":{"it":"Borsa della collezione Golf CROWN con manici e logo. Da abbinare agli accessori coordinati della linea.","en":"A bag with handles and CROWN branding from the Golf collection. Pair with the line’s coordinated accessories.","nameEn":"Structured Tote"},"CG-A04":{"it":"Cappellino con visiera e logo CROWN. Accessorio della collezione Golf.","en":"A cap with a brim and CROWN logo from the Golf collection.","nameEn":"Cap"},"CG-A05":{"it":"Visiera Golf con logo CROWN e parte superiore aperta.","en":"An open-top Golf visor with CROWN branding.","nameEn":"Visor"},"CG-A06":{"it":"Guanto Golf CROWN. Scegli la taglia tra S, M, L e XL; per misure e indicazione della mano contatta l’assistenza prima dell’ordine.","en":"A CROWN Golf glove. Choose S, M, L or XL; contact customer care before ordering for measurements and handedness.","nameEn":"Golf Glove"},"CG-A07":{"it":"Scarpe Golf uomo CROWN con lacci e dettagli a contrasto. Numeri disponibili nel selettore: dal 39 al 46.","en":"Men’s lace-up CROWN Golf shoes with contrasting details. Sizes in the selector range from EU 39 to 46.","nameEn":"Men’s Luxury Golf Shoes"},"CG-A08":{"it":"Calze della collezione Golf CROWN. Per lunghezza e intervallo di calzata, chiedi le misure all’assistenza prima di ordinare.","en":"Socks from the CROWN Golf collection. Ask customer care for length and fit range before ordering.","nameEn":"Golf Socks"},"CG-A09":{"it":"Asciugamano della collezione Golf CROWN, con logo e bordi a contrasto.","en":"A Golf collection towel with CROWN branding and contrasting edging.","nameEn":"Golf Towel"},"CG-A10":{"it":"Custodia porta palline della collezione Golf CROWN. Per capacità e dotazione inclusa, contatta l’assistenza prima dell’ordine.","en":"A golf ball pouch from the CROWN collection. Contact customer care before ordering for capacity and included items.","nameEn":"Ball Pouch"},"CG-A11":{"it":"Porta score della collezione Golf CROWN, per completare la selezione di accessori da campo.","en":"A scorecard holder from the CROWN Golf collection, part of the course accessories selection.","nameEn":"Scorecard Holder"},"CG-A12":{"it":"Set di coprimazze della collezione Golf CROWN. Prima dell’ordine, contatta l’assistenza per confermare componenti e compatibilità con le tue mazze.","en":"A set of club headcovers from the CROWN Golf collection. Before ordering, ask customer care to confirm the pieces included and compatibility with your clubs.","nameEn":"Club Headcover Set"},"CG-A13":{"it":"Bracciale della collezione Golf CROWN. Prima dell’acquisto, chiedi all’assistenza la composizione e le misure specifiche del modello.","en":"A bracelet from the CROWN Golf collection. Before buying, ask customer care for the style’s material composition and measurements.","nameEn":"Golf Bracelet"},"CG-A14":{"it":"Tracolla a catena della collezione Golf CROWN. Chiedi all’assistenza lunghezza e compatibilità degli agganci prima dell’acquisto.","en":"A chain shoulder strap from the CROWN Golf collection. Ask customer care about its length and clasp compatibility before buying.","nameEn":"Chain Shoulder Strap"},"CG-A15":{"it":"Elastico per capelli della collezione Golf CROWN. Un accessorio da abbinare al look della linea.","en":"A hair tie from the CROWN Golf collection, designed to complement the collection’s looks.","nameEn":"Hair Tie"},"CG-A16":{"it":"Portachiavi della collezione Golf CROWN. Un piccolo accessorio con i dettagli distintivi del marchio.","en":"A keyring from the CROWN Golf collection, featuring the brand’s signature details.","nameEn":"Keyring"},"CG-A17":{"it":"Cintura uomo CROWN della collezione Golf. Taglie S, M e L; chiedi all’assistenza la lunghezza in centimetri prima di scegliere.","en":"A men’s CROWN Golf belt. Sizes S, M and L; ask customer care for the length in centimetres before choosing.","nameEn":"Men’s Belt"},"CG-A18":{"it":"Cintura donna CROWN della collezione Golf. Taglie S, M e L; chiedi all’assistenza la lunghezza in centimetri prima di scegliere.","en":"A women’s CROWN Golf belt. Sizes S, M and L; ask customer care for the length in centimetres before choosing.","nameEn":"Women’s Belt"},"CG-A19":{"it":"Scarpe Golf donna CROWN con lacci e dettagli a contrasto. Numeri disponibili nel selettore: dal 36 al 41.","en":"Women’s lace-up CROWN Golf shoes with contrasting details. Sizes in the selector range from EU 36 to 41.","nameEn":"Women’s Golf Shoes"},"CG-A20":{"it":"Pochette porta accessori della collezione Golf CROWN. Chiedi all’assistenza le dimensioni specifiche prima dell’ordine.","en":"An accessory pouch from the CROWN Golf collection. Ask customer care for exact dimensions before ordering.","nameEn":"Accessory Pouch"},"CRN-W-BLA-001":{"it":"Blazer donna dalla linea sagomata, con collo alto, chiusura zip e dettagli oro. Taschino sul petto e tasche con pattina.","en":"A shaped women’s blazer with a stand collar, zip fastening and gold accents. Chest pocket and flap pockets.","nameEn":"The Adaptive Blazer"},"CRN-W-PAN-001":{"it":"Vita alta. Gamba ampia. Zip oro sulle tasche. Linea lunga. Chiusura laterale.","en":"High waist. Wide leg. Gold pocket zips. Long silhouette. Side fastening.","nameEn":"The Travel Pant"},"CRN-W-JAC-001":{"it":"Chiusura full-zip. Collo rialzabile. Tasche con zip oro. Linea sagomata. Zip ai polsini.","en":"Full-zip fastening. Stand-up collar. Gold zipped pockets. Shaped silhouette. Zipped cuffs.","nameEn":"The Transit Jacket"},"CRN-W-DRE-001":{"it":"Spalline larghe. Scollo squadrato. Spacco laterale con zip. Zip sul retro. Logo sul petto.","en":"Wide straps. Square neckline. Zipped side slit. Back zip. Chest logo.","nameEn":"The Travel Dress"},"CRN-M-TRO-001":{"it":"Pantalone dalla linea sartoriale, con vita comfort e tasche discrete.","en":"Tailored trousers with a comfort waistband and discreet pockets.","nameEn":"The Travel Trouser"},"CRN-M-JAC-001":{"it":"Giacca full-zip essenziale, con collo pulito e dettagli oro.","en":"An understated full-zip jacket with a clean collar and gold accents.","nameEn":"The Transit Jacket"},"CRN-M-TEE-001":{"it":"T-shirt girocollo dal disegno essenziale.","en":"A clean crew-neck T-shirt.","nameEn":"The Essential Tee"},"CRN-M-OVS-001":{"it":"Sovracamicia con bottoni e tasche applicate, pensata per abbinamenti da viaggio e città.","en":"An overshirt with buttons and patch pockets, styled for travel and city outfits.","nameEn":"The Travel Overshirt"},"CRN-M-HOO-001":{"it":"Felpa con cappuccio e dettagli oro.","en":"A hoodie with gold details.","nameEn":"The Merino Hoodie"},"CRN-M-BLA-001":{"it":"Blazer dal design versatile, presentato nella tavola in abbinamenti travel, sport e sera.","en":"A versatile blazer shown in travel, sport and evening combinations.","nameEn":"The Adaptive Blazer"},"CRN-M-POL-001":{"it":"Polo a maniche corte con profili oro e logo sul petto.","en":"A short-sleeve polo with gold trims and a chest logo.","nameEn":"The Performance Polo"},"CRN-M-BPK-001":{"it":"Zaino da viaggio e città con tasca frontale e spallacci regolabili.","en":"A travel and city backpack with a front pocket and adjustable straps.","nameEn":"The Luxury Backpack"},"CRN-M-WEK-001":{"it":"Borsone da viaggio con doppi manici e tracolla removibile.","en":"A travel holdall with twin handles and a removable shoulder strap.","nameEn":"The Weekender"},"CS-M01":{"it":"T-shirt aderente a girocollo con logo sul petto.","en":"Fitted crew-neck tee with chest logo.","nameEn":"Core Support Tee"},"CS-M02":{"it":"Polo a maniche corte con chiusura a bottoni.","en":"Short-sleeve polo with button placket.","nameEn":"Travel Sculpt Polo"},"CS-M03":{"it":"Canotta da indossare come strato base.","en":"Tank top designed as a base layer.","nameEn":"Second-Skin Base Layer"},"CS-M04":{"it":"Boxer con fascia in vita e cuciture sagomate.","en":"Boxer shorts with waistband and contoured seams.","nameEn":"Sculpt Short"},"CS-M05":{"it":"Pantalone dalla linea sartoriale con fascia interna in vita.","en":"Tailored trousers with an internal waistband.","nameEn":"Travel Trouser+"},"CS-M06":{"it":"Sovracamicia con bottoni e tasche sul petto.","en":"Buttoned overshirt with chest pockets.","nameEn":"Motion Sculpt Overshirt"},"CS-W01":{"it":"Reggiseno con spalline e coppe sagomate.","en":"Bra with shoulder straps and shaped cups.","nameEn":"Sculpt Support Bra"},"CS-W02":{"it":"T-shirt aderente con struttura interna integrata.","en":"Fitted tee with an integrated inner structure.","nameEn":"2-in-1 Sculpt Tee"},"CS-W03":{"it":"Abito Sculpt con spalline larghe, scollo squadrato e drappeggio laterale. Colori: bianco, beige e nero. La fotografia principale mostra la variante nera; per immagini specifiche di bianco e beige contatta l’assistenza prima dell’acquisto.","en":"A Sculpt dress with wide straps, a square neckline and side draping. Colours: white, beige and black. The main photograph shows black; contact customer care before buying for specific images of white and beige.","nameEn":"Travel Sculpt Dress"},"CS-W04":{"it":"Pantalone aderente a vita alta con cuciture sagomate.","en":"High-waisted fitted pants with contoured seams.","nameEn":"Sculpt Pant"},"CS-W05":{"it":"Short sottoveste a vita alta.","en":"High-waisted underlayer shorts.","nameEn":"Second-Skin Shaping Short"},"CS-W06":{"it":"Gonna con drappeggio e short interno.","en":"Draped skirt with inner shorts.","nameEn":"Sculpt Skirt"},"CRN-W-KNI-001":{"it":"Girocollo a costina. Zip oro sulla spalla. Zip ai polsini. Bordo a costina. Logo sul petto.","en":"Ribbed crew neck. Gold shoulder zip. Zipped cuffs. Ribbed hem. Chest logo.","nameEn":"The Soft Knit"},"CRN-W-TEE-001":{"it":"Girocollo. Maniche corte. Zip laterali. Zip posteriore. Logo sul petto.","en":"Crew neck. Short sleeves. Side zips. Back zip. Chest logo.","nameEn":"The Essential Tee"},"CS-W-ECL-001":{"it":"Abito midi con scollo a cuore, spalline sottili e dettagli metallici color oro. Il modello integra un body interno. Disponibile in bianco e nero, nelle taglie da XS a XL.","en":"A midi dress with a sweetheart neckline, slim straps and gold-tone metal details. The style has an integrated bodysuit. Available in white and black, in sizes XS to XL.","nameEn":"Sculpt Éclat Midi"}};
window.CROWN_PRODUCTS.forEach(p=>{const c=CROWN_PRODUCT_COPY_20261031[p.id];if(c){p.description=c.it;p.en=c.en;p.nameEn=c.nameEn;}if(p.id==='CS-W-ECL-001'){p.details=['Scollo a cuore','Spalline sottili','Lunghezza midi','Body interno integrato','Dettagli metallici color oro'];p.detailsEn=['Sweetheart neckline','Slim straps','Midi length','Integrated bodysuit','Gold-tone metal details'];}});
